import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import MassMessageModal from "../Material/MassMessageModal"
import { Row, Col, Input } from "reactstrap"
import BulkRepAssignment from "../Material/BulkRepAssignment"
import ConfirmationPopup from "../Material/ConfirmationPopup"
import { HasPermissionsQuery } from "../Functions/querys"
import updateFilters from "../Functions/updateFilters"
import TableColumnPreferenceControl from "../Material/TableColumnPreferenceControl"
import withApolloClient from "../withApolloClient"
import AdvancedFiltersControl from "../Filters/AdvancedFiltersControl"
import AppliedAdvancedFilters from "../Filters/AppliedAdvancedFilters"


const RepAssignment = gql`mutation BulkRepAssignment($input:BulkRepAssignmentMutationInput!){
    bulkRepAssignment(input:$input){
        errors{
            messages
        }
        ok
    }
}`
const BulkArchiveLead = gql`mutation  BulkArchiveLead($input:BulkArchiveLeadInput!){
    bulkArchiveLead(input:$input){
        errors{
            messages
        }
        ok
    }
}`

class LeadsListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
            filterValues: this.props.filterValues,
            loading: false,
            error: "",
        }
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    unAssignReps = () => {
        let input = {
            objectIds: this.props.selectedLeads.map(item => item.id),
        }

        this.props.apolloClient.mutate({
            mutation: RepAssignment,
            variables: { input }
        }).then((result) => {
            this.props.refetchQuery()
            this.props.handleClose()
        })
    }
    
    updateSearchTerm = (searchTerm) => {
        updateFilters({ ...this.props.filterValues, searchTerm }, [], this.props.navigate, this.props.location, this.props.setFilterValues)
    }

    handleBulkArchiveLeads = () => {
        this.setState({ loading: true })
        let input = {
            leadIds: this.props.selectedLeads.map(item => item.id),
        }

        this.props.apolloClient.mutate({
            mutation: BulkArchiveLead,
            variables: { input }
        }).then((result) => {
            if (result && result.data && result.data.bulkArchiveLead && result.data.bulkArchiveLead.ok) {
                this.props.refetchQuery()
                this.toggleModal("")
                this.setState({ input: {}, loading: false, error: null })
            } else if (result.data && result.data.bulkArchiveLead.errors && result.data.bulkArchiveLead.errors.length > 0) {
                this.setState({ loading: false, error: result.data.bulkArchiveLead.errors[0].messages[0] })
            }
        }).catch((err) => {
            this.setState({ loading: false, error: err })
        })
    }

    render() {
        return (
            <Row className="align-items-center">
                {this.state.openModal === "MassMessageModal" && <MassMessageModal handleClose={() => this.toggleModal("MassMessageModal")} open={this.state.openModal === "MassMessageModal"} drivers={null} />}
                {this.state.openModal === "BulkAssignmentModal" && <BulkRepAssignment
                    open={this.state.openModal === "BulkAssignmentModal"}
                    title={"Assign " + this.props.selectedLeads.length + " Selected Drivers to Reps"}
                    selectedObjectIds={this.props.selectedLeads.map(item => item.id)}
                    handleClose={() => this.toggleModal(false)}
                    refetchQuery={this.props.refetchQuery}
                    groups={["Sales Team"]}
                />}
                {this.state.openModal === "confirmation" && <ConfirmationPopup
                    open={this.state.openModal === "confirmation"}
                    message={"Unassign " + this.props.selectedLeads.length + " Selected Applications"}
                    handleClose={() => this.toggleModal("confirmation")}
                    action={"Yes"}
                    confirmAction={this.unAssignReps}
                    color="danger"
                />}
                {this.state.openModal === "BulkArchiveLead" && <ConfirmationPopup
                    open={this.state.openModal === "BulkArchiveLead"}
                    message={"Are you sure you want to archive " + this.props.selectedLeads.length + " selected leads?"}
                    handleClose={() => this.toggleModal("BulkArchiveLead")}
                    action={"Yes"}
                    confirmAction={this.handleBulkArchiveLeads}
                    color="danger"
                    loading={this.state.loading}
                    error={this.state.error ? this.state.error : ""}
                />}
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} key={`searchTerm-${this.props.activeTab}`} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs={2} className="p-0">
                    <AdvancedFiltersControl entity="lead" presets={this.props.presets} setPresets={this.props.setPresets} defaultPresets={this.props.defaultPresets} />
                </Col>
                <Col xs={6} className="text-right mt-2">
                    <a className="driver-list-button" onClick={() => this.toggleModal("MassMessageModal")}>
                        Message Drivers | <i className="fa fa-commenting-o" aria-hidden="true"></i>
                    </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    {this.props.hasPermissions && this.props.hasPermissions.includes("delete_lead") && this.props.selectedLeads.length > 0 && <>
                        <a className="driver-list-button" onClick={() => this.toggleModal("BulkArchiveLead")}>
                            Bulk Archive | <i className="fa fa-trash-o" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </>}
                    {this.props.hasPermissions && this.props.hasPermissions.includes("custom_can_edit_lead_rep") && this.props.selectedLeads.length > 0 && <>
                        <a className="driver-list-button" onClick={() => this.toggleModal("confirmation")}>
                            Unassign Rep | <i className="fa fa-minus" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                        <a className="driver-list-button" onClick={() => this.toggleModal("BulkAssignmentModal")}>
                            Assign Rep | <i className="fa fa-plus" aria-hidden="true"></i>
                        </a>&nbsp;&nbsp;&nbsp;&nbsp;
                    </>}
                    <TableColumnPreferenceControl
                        tableId={this.props.tableId}
                        columnConfig={this.props.columnConfig}
                        setColumnConfig={this.props.setColumnConfig}
                        defaultColumnConfig={this.props.defaultColumnConfig}
                        buttonLabel="Preference"
                    />
                </Col>
                <Col xs={12} className="mt-2 mb-2">
                    {this.props.selectedLeads && this.props.selectedLeads.length > 0 && <span className="search-filter-preview">
                        <span> <i className="fa fa-times-circle" onClick={this.props.resetSelectedLeads}></i> &nbsp;&nbsp; Selected Leads</span>
                        {this.props.selectedLeads.length}
                    </span>}
                    <AppliedAdvancedFilters entity="lead" context={null} presets={this.props.presets} onPresetsChange={this.props.setPresets} />
                </Col>
            </Row >
        )
    }
}


//-----------------------------------
export default graphql(HasPermissionsQuery, {
    options: () => ({ variables: { userPermissions: ["custom_can_edit_lead_rep", "delete_lead"] }, fetchPolicy: "network-only", notifyOnNetworkStatusChange: true }),
    props: ({ data: { hasPermissions, loading, variables } }) => ({
        hasPermissions, loading, variables
    })
})(withApolloClient(LeadsListHeader))
